export default __webpack_public_path__ + "static/media/dinner.dab1b60f.png";